// extracted by mini-css-extract-plugin
export default {"header-home":"Home_header-home__EDzo0","header-style-info":"Home_header-style-info__gdBR8","h1":"Home_h1__sWiEz","h2":"Home_h2__SEa1d","title-style":"Home_title-style__sF0p+"};